import React, { useState, useEffect } from 'react';
import API from '../services/api';

function AdminBonusPage() {
  // We store how many weeks to fetch at a time (default = 4)
  const [weekCount, setWeekCount] = useState(4);
  const [grouped, setGrouped] = useState({});

  useEffect(() => {
    fetchBonuses();
  }, [weekCount]); // re-fetch whenever weekCount changes

  const fetchBonuses = async () => {
    try {
      // pass ?count=weekCount to let the server know how many weeks we want
      const res = await API.get(`/admin/therapist-bonuses?count=${weekCount}`);
      // res.data is a flat array: each item = {therapist_id, therapist_name, week_start, week_end, ...}
      // We'll group them by therapist_id so we can show them grouped
      const byTherapist = {};
      res.data.forEach(item => {
        if (!byTherapist[item.therapist_id]) {
          byTherapist[item.therapist_id] = {
            therapist_name: item.therapist_name,
            rows: []
          };
        }
        byTherapist[item.therapist_id].rows.push({ ...item });
      });
      setGrouped(byTherapist);
    } catch (err) {
      console.error(err);
      alert('Error fetching bonuses');
    }
  };

  const handleBonusChange = (therapistId, rowIndex, newValue) => {
    const newGrouped = { ...grouped };
    const rowsCopy = [...newGrouped[therapistId].rows];
    rowsCopy[rowIndex] = {
      ...rowsCopy[rowIndex],
      bonus_amount: newValue,
      is_approved: false // reset approval if changed
    };
    newGrouped[therapistId].rows = rowsCopy;
    setGrouped(newGrouped);
  };

  const saveBonus = async (therapistId, rowIndex) => {
    const row = grouped[therapistId].rows[rowIndex];
    try {
      // Use row.week_start for the DB so it matches the backend’s logic
      await API.post('/admin/therapist-bonuses', {
        therapistId: row.therapist_id,
        weekStart: row.week_start, // the real Sunday
        weekEnd: row.week_end,     // the Saturday
        bonusAmount: parseFloat(row.bonus_amount) || 0
      });
      alert('Bonus saved!');
      fetchBonuses();
    } catch (err) {
      console.error(err);
      alert('Error saving bonus');
    }
  };

  const approveBonus = async (bonusId) => {
    try {
      await API.put(`/admin/therapist-bonuses/${bonusId}/approve`);
      alert('Bonus approved!');
      fetchBonuses();
    } catch (err) {
      console.error(err);
      alert('Error approving bonus');
    }
  };

  // Called when user clicks "Load Older Weeks" - we add 4 more weeks each time.
  const handleLoadOlderWeeks = () => {
    setWeekCount(prev => prev + 4);
  };

  return (
    <div style={{ margin: '2rem' }}>
      <h2>Therapist Bonuses</h2>

      {/* Button to load older weeks */}
      <button onClick={handleLoadOlderWeeks} style={{ marginBottom: '1rem' }}>
        Load Older Weeks
      </button>

      {Object.keys(grouped).length === 0 && (
        <p>No bonus data found.</p>
      )}

      {Object.keys(grouped).map(therapistId => {
        const therapistName = grouped[therapistId].therapist_name;
        const therapistRows = grouped[therapistId].rows;

        return (
          <div key={therapistId} style={{ marginBottom: '2rem' }}>
            {/* Therapist Name */}
            <h3>{therapistName}</h3>

            {/* Table for each therapist's weeks */}
            <table border="1" cellPadding="5" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr>
                  <th>Week</th>
                  <th>Sessions Billed</th>
                  <th>Sessions Collected</th>
                  <th>Total Billed</th>
                  <th>Total Collected</th>
                  <th>Bonus Amount</th>
                  <th>Approved?</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {therapistRows.map((row, idx) => (
                  <tr key={`${row.week_start}-${idx}`}>
                    {/* We display “Week ending on ...”, even though week_start is used in DB */}
                    <td>Week ending on {row.week_end}</td>
                    <td>{row.sessions_billed}</td>
                    <td>{row.sessions_collected}</td>
                    <td>${row.total_billed.toFixed(2)}</td>
                    <td>${row.total_collected.toFixed(2)}</td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        value={row.bonus_amount}
                        disabled={row.is_approved}
                        onChange={(e) => handleBonusChange(therapistId, idx, e.target.value)}
                        style={{ width: '80px' }}
                      />
                    </td>
                    <td>{row.is_approved ? 'Yes' : 'No'}</td>
                    <td>
                      <button
                        onClick={() => saveBonus(therapistId, idx)}
                        disabled={row.is_approved}
                      >
                        Save
                      </button>
                      {' '}
                      {row.bonus_id && !row.is_approved && (
                        <button onClick={() => approveBonus(row.bonus_id)}>
                          Approve
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

export default AdminBonusPage;
